/**
 * Format-konforme Beispiel-Platzhalter für die Anlage-Inputs. Werden als
 * `placeholder` verwendet, damit der Nutzer das erwartete Format sofort sieht.
 */
export const PLACEHOLDERS = {
  phoneMobile: "+49 151 23456789",
  phoneLandline: "+49 30 1234567",
  fax: "+49 30 1234560",
  email: "name@firma.de",
  iban: "DE12 3456 7890 1234 5678 90",
  bic: "MARKDEF1100",
  ustIdNr: "DE123456789",
  steuernummer: "12/345/67890 oder 13-stellig",
  plz: "80331",
  city: "München",
  street: "Straße & Hausnummer eingeben …",
  legalForm: "z. B. GmbH",
  registerNumber: "12312",
  finanzamt: "Ort, Name, Amtsnummer oder PLZ — z. B. München",
  nationality: "Deutsch",
  memberships: "Verband/Verein eingeben + Enter",
  social: {
    linkedin: "https://linkedin.com/in/…",
    instagram: "https://instagram.com/…",
    facebook: "https://facebook.com/…",
    tiktok: "https://tiktok.com/@…",
    xing: "https://xing.com/profile/…",
    youtube: "https://youtube.com/@…",
  },
} as const;
